import type { BuildingEntityType } from "building-types/entities/buildingEntityTypeTypes";
import type { Label, LabelableEntityBase } from "building-types/entities/labelTypes";
import type { Formula } from "building-types/options/formula";
import type { Table } from "common/data/table";

export enum SelectionMethod {
  ALL = "ALL",
  BY_LABEL = "BY_LABEL",
  BY_SELECTOR = "BY_SELECTOR",
}

export type RuleBasedSelectorBuildingEntityType = Extract<BuildingEntityType, "ANNOTATION" | "PROP" | "CEILING">;
export const RuleBasedSelectorBuildingEntityTypes: RuleBasedSelectorBuildingEntityType[] = [
  "ANNOTATION",
  "PROP",
  "CEILING",
];

export type CompiledSelectorFormulasByEntityType = { [key in RuleBasedSelectorBuildingEntityType]?: Formula };

export interface SerializableAllSelector {
  selectionMethod: SelectionMethod.ALL;
}

export interface SerializableLabelSelector extends LabelableEntityBase {
  selectionMethod: SelectionMethod.BY_LABEL;
}

export interface SerializableRuleBasedSelector {
  selectionMethod: SelectionMethod.BY_SELECTOR;
  formulas: CompiledSelectorFormulasByEntityType[];
  docLabels: Table<Label>; // Copied from doc.labels. Stored here to avoid the inconvenience of plumbing the labels table through many layers of code.
}

export type SerializableSheetGeometrySelector =
  | SerializableAllSelector
  | SerializableLabelSelector
  | SerializableRuleBasedSelector;
